import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { SiteProvider } from "@/context/SiteContext";
import RequireAuth from "@/components/RequireAuth";
import AppLayout from "@/components/AppLayout";
import { ensureServiceWorker } from "@/lib/push";
import LoginPage from "@/pages/LoginPage";
import QueuePage from "@/pages/QueuePage";
import DraftDetailPage from "@/pages/DraftDetailPage";
import FeedsPage from "@/pages/FeedsPage";
import LogsPage from "@/pages/LogsPage";
import SettingsPage from "@/pages/SettingsPage";
import SitesPage from "@/pages/SitesPage";
import PoliticsAlertsPage from "@/pages/PoliticsAlertsPage";
import PoliticsFeedsPage from "@/pages/PoliticsFeedsPage";
import PoliticsSettingsPage from "@/pages/PoliticsSettingsPage";
import PoliticsCategoriesPage from "@/pages/PoliticsCategoriesPage";
import PoliticsCategoryDetailPage from "@/pages/PoliticsCategoryDetailPage";

function Protected({ children }) {
  return (
    <RequireAuth>
      <SiteProvider>
        <AppLayout>{children}</AppLayout>
      </SiteProvider>
    </RequireAuth>
  );
}

// Fullscreen wrapper (no bottom nav) for draft detail
function ProtectedFullscreen({ children }) {
  return (
    <RequireAuth>
      <SiteProvider>{children}</SiteProvider>
    </RequireAuth>
  );
}

function App() {
  useEffect(() => { ensureServiceWorker(); }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<Protected><QueuePage /></Protected>} />
            <Route path="/flux" element={<Protected><FeedsPage /></Protected>} />
            <Route path="/journal" element={<Protected><LogsPage /></Protected>} />
            <Route path="/reglages" element={<Protected><SettingsPage /></Protected>} />
            <Route path="/sites" element={<Protected><SitesPage /></Protected>} />
            <Route path="/veille" element={<Protected><PoliticsAlertsPage /></Protected>} />
            <Route path="/veille/categories" element={<Protected><PoliticsCategoriesPage /></Protected>} />
            <Route path="/veille/categories/:id" element={<Protected><PoliticsCategoryDetailPage /></Protected>} />
            <Route path="/veille/flux" element={<Protected><PoliticsFeedsPage /></Protected>} />
            <Route path="/veille/reglages" element={<Protected><PoliticsSettingsPage /></Protected>} />
            <Route path="/brouillon/:id" element={<ProtectedFullscreen><DraftDetailPage /></ProtectedFullscreen>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
